import React from 'react';
import { Alert, Spinner, Container } from 'react-bootstrap';
import { useUI } from '../../context/UIContext';
import { useAuth } from '../../context/AuthContext';
import Header from '../common/Header';
import Footer from '../common/Footer';
import SessionTimeoutWarning from '../common/SessionTimeoutWarning';
import '../../styles/AppLayout.scss';

/**
 * Global app layout component that provides:
 * - Full-screen loading overlay
 * - Global alert/notification bar
 * - Header with navigation
 * - Footer with confidentiality notice
 *
 * Wrap the entire app with this component to enable global loading and alerts.
 */
const AppLayout = ({ children }) => {
  const { loading, alert, hideAlert } = useUI();
  const { isAuthenticated, passedMfa } = useAuth();

  return (
    <>
      {/* Inactivity warning + auto-logout (only for authenticated/MFA-passed sessions) */}
      {isAuthenticated && passedMfa && <SessionTimeoutWarning />}

      {/* Global Loading Overlay */}
      {loading.show && (
        <div className="global-loading-overlay">
          <div className="global-loading-content">
            <Spinner animation="border" variant="light" role="status">
              <span className="visually-hidden">{loading.message}</span>
            </Spinner>
            <p className="mt-3">{loading.message}</p>
          </div>
        </div>
      )}

      {/* Global Alert */}
      {alert.show && (
        <div className="global-alert-container">
          <Alert
            variant={alert.type}
            dismissible={alert.dismissible}
            onClose={hideAlert}
          >
            {alert.message}
          </Alert>
        </div>
      )}

      {/* Header */}
      <Container fluid className="py-4 d-flex flex-column min-vh-100">
        <Header />

        {/* Page Content */}
        <main className={loading.show ? 'content-hidden' : ''}>
          {children}
        </main>

        {/* Footer */}
        <div className="mt-auto">
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default AppLayout;